import Decimal from 'decimal.js';
import { insuranceFields } from './insurance-fields';
import type { TradeInput } from './schema';
import type { ValidationIssue } from './validation';

export function validateInsurance(input: TradeInput): ValidationIssue[] {
  const issues: ValidationIssue[] = [];
  for (const field of insuranceFields) {
    if ('required' in field && field.required && !input[field.field]) issues.push({
      code: 'INSURANCE_REQUIRED', path: field.field, severity: 'ERROR', message: '请补充' + field.label + '。',
    });
  }
  if (input.insuredAmount && !new Decimal(input.insuredAmount).greaterThan(0)) issues.push({
    code: 'INSURANCE_AMOUNT_INVALID', path: 'insuredAmount', severity: 'ERROR', message: '保险金额必须大于 0。',
  });
  for (const [field, message] of [
    ['surveyAgent', '请核对检验代理人，当前为空。'],
    ['insuranceDeclaration', '保险条款声明尚未提供，请在导出前核对。'],
    ['applicantSignature', '投保人签章信息为空。'],
    ['insurerSignature', '保险公司签章信息为空。'],
  ] as const) if (!input[field]) issues.push({ code: 'INSURANCE_REVIEW', path: field, severity: 'WARNING', message });
  return issues;
}
